import 'modules/integrations/integration'


class window.IntegrationManager
  constructor: ->
    @salesforce = new Integration("salesforce", "Salesforce")
